var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nx-profile-editor',{attrs:{"title":_vm.$t('message.menu.myprofile'),"id":_vm.staffId,"tab":"editor","entity":"profile"}})}
var staticRenderFns = []

export { render, staticRenderFns }